import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

import {AgentNumber, UserAssignedAgentNumber} from 'ApplicationEntry/models/AgentNumber';
import {AgentInformation} from '../models/AgentInformation';
import * as A from '../models/AgentInformation';

import {Async} from 'Core/models/Async';
import {StringUnion} from 'Core/models/EmptyString';

export enum AgentInformationActionType {
  UPDATE_AGENT = 'agent/UPDATE_AGENT',
  EMPTY_AGENT = 'agent/EMPTY_AGENT',
  UPDATE_AGENT_NO = 'agent/UPDATE_AGENT_NO',
  UPDATE_AGENT_NAME = 'agent/UPDATE_AGENT_NAME',
  UPDATE_AGENT_DETAILS = 'agent/UPDATE_AGENT_DETAILS',
  UPDATE_PERCENT = 'agent/UPDATE_PERCENT',
  UPDATE_SIGNED = 'agent/UPDATE_SIGNED',
  EDIT_AGENT = 'agent/EDIT_AGENT',
  GET_AGENT_NAME = 'agent/GET_AGENT_NAME',
  GET_AGENT_NUMBER_MESSAGE = 'billingAgent/GET_AGENT_NUMBER_MESSAGE',
  CHANGE_USER_AGENT_NUMBER = 'billingAgent/CHANGE_USER_AGENT_NUMBER',
  IS_ALLSTATE_AFFILIATED = 'billingAgent/IS_ALLSTATE_AFFILIATED',
  UPDATE_ALLSTATE_AFFILIATED = 'billingAgent/UPDATE_ALLSTATE_AFFILIATED',
}

export const updateAgentValues = (
  agentNumber: AgentNumber,
  agentName: StringUnion,
  percent: number,
  signed: boolean,
  allstateAffiliated: boolean
) =>
  createAction(AgentInformationActionType.UPDATE_AGENT, {
    agentNumber,
    agentName,
    percent,
    signed,
    allstateAffiliated,
  });

export const updateAgentNumber = (agentNumber: Async<string>) =>
  createAction(AgentInformationActionType.UPDATE_AGENT_NO, {agentNumber});
export const updateUserAgentNumber = (agentNumber: string) =>
  createAction(AgentInformationActionType.CHANGE_USER_AGENT_NUMBER, {agentNumber});
export const updateAgentNumberError = (agentNumber: string) =>
  createAction(AgentInformationActionType.GET_AGENT_NUMBER_MESSAGE, {agentNumber});
export const updateAgentName = (agentName: string) =>
  createAction(AgentInformationActionType.UPDATE_AGENT_NAME, {agentName});
export const updateAllstateAffiliated = (allstateAffiliated: boolean) =>
  createAction(AgentInformationActionType.UPDATE_ALLSTATE_AFFILIATED, {allstateAffiliated});
export const updatePercent = (percent: number) => createAction(AgentInformationActionType.UPDATE_PERCENT, {percent});
export const updateSigned = (signed: boolean) => createAction(AgentInformationActionType.UPDATE_SIGNED, {signed});
export const emptyAgent = () => createAction(AgentInformationActionType.EMPTY_AGENT);
export const editAgent = (agentInformation: AgentInformation) =>
  createAction(AgentInformationActionType.EDIT_AGENT, {agentInformation});
export const getAgentName = (agentNumber: UserAssignedAgentNumber) =>
  createAction(AgentInformationActionType.GET_AGENT_NAME, {agentNumber});
export const isAllstateAffiliated = (agentInformation: AgentInformation, editAgent: boolean, agentIndex: number) =>
  createAction(AgentInformationActionType.IS_ALLSTATE_AFFILIATED, {agentInformation, editAgent, agentIndex});

export type AgentInformationAction =
  | ReturnType<typeof updateAgentValues>
  | ReturnType<typeof updateAgentNumber>
  | ReturnType<typeof updateUserAgentNumber>
  | ReturnType<typeof updateAgentNumberError>
  | ReturnType<typeof updateAgentName>
  | ReturnType<typeof updatePercent>
  | ReturnType<typeof updateAllstateAffiliated>
  | ReturnType<typeof updateSigned>
  | ReturnType<typeof emptyAgent>
  | ReturnType<typeof editAgent>
  | ReturnType<typeof getAgentName>
  | ReturnType<typeof isAllstateAffiliated>;

export const isAgentInformationAction = (action: any): action is AgentInformationAction =>
  action.type in reverseEnum(AgentInformationActionType);

type AgentInformationState = AgentInformation;
const DEFAULT_STATE: AgentInformationState = A.EmptyAgent;

export default (state: AgentInformationState = DEFAULT_STATE, action: AgentInformationAction) => {
  switch (action.type) {
    case AgentInformationActionType.UPDATE_AGENT:
      return A.updateAgentValues(
        action.payload.agentNumber,
        action.payload.agentName,
        action.payload.percent,
        action.payload.signed,
        action.payload.allstateAffiliated
      )();
    case AgentInformationActionType.UPDATE_AGENT_NO:
      return A.changeAgentNumber(action.payload.agentNumber)(state);
    case AgentInformationActionType.GET_AGENT_NUMBER_MESSAGE:
      return A.changeAgentNumberError(action.payload.agentNumber)(state);
    case AgentInformationActionType.CHANGE_USER_AGENT_NUMBER:
      return A.changeUserAgentNumber(action.payload.agentNumber)(state);
    case AgentInformationActionType.UPDATE_AGENT_NAME:
      return A.changeAgentName(action.payload.agentName)(state);
    case AgentInformationActionType.UPDATE_PERCENT:
      return A.changePercent(action.payload.percent)(state);
    case AgentInformationActionType.UPDATE_SIGNED:
      return A.changeSigned(action.payload.signed)(state);
    case AgentInformationActionType.EMPTY_AGENT:
      return A.EmptyAgent;
    case AgentInformationActionType.UPDATE_ALLSTATE_AFFILIATED:
      return A.changeAllstateAffiliated(action.payload.allstateAffiliated)(state);
    default:
      return state;
  }
};
